import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const decoded = jwtDecode(token);
          // Verifier si le token est expire cote client
          const now = Math.floor(Date.now() / 1000);
          if (decoded.exp && decoded.exp < now) {
            localStorage.removeItem('token');
            return;
          }
          setUser({
            id: decoded.id,
            email: decoded.email,
            prenom: decoded.prenom || '',
            nom: decoded.nom || ''
          });
        } catch (error) {
          console.error('Token invalide:', error);
          localStorage.removeItem('token');
        }
      }
    } catch (e) {
      console.warn('localStorage error:', e.message);
    }
  }, []);

  // Intercepteur axios global pour le refresh automatique du JWT
  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        // Si le serveur envoie un nouveau token, le mettre a jour
        const newToken = response.headers['x-new-token'];
        if (newToken) {
          localStorage.setItem('token', newToken);
          try {
            const decoded = jwtDecode(newToken);
            setUser({
              id: decoded.id,
              email: decoded.email,
              prenom: decoded.prenom || '',
              nom: decoded.nom || ''
            });
            console.log('Token rafraîchi automatiquement');
          } catch (error) {
            console.error('Erreur decodage nouveau token:', error);
          }
        }
        return response;
      },
      (error) => {
        // Si le token est expire (401), deconnecter l'utilisateur
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          setUser(null);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  const login = (token) => {
    localStorage.setItem('token', token);
    const decoded = jwtDecode(token);
    setUser({
      id: decoded.id,
      email: decoded.email,
      prenom: decoded.prenom || '',
      nom: decoded.nom || ''
    });
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
